export default "__VITE_ASSET__DPe514nU__"